import React from 'react';
import ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/styled-engine';
import { BrowserRouter } from 'react-router-dom';
import { GlobalContextProvider } from 'Global/Context/GlobalContextProvider';
import App from 'EntryPoint/App';
import { MuiProvider } from 'Global/Theme/Provider/MuiProvider';
import './Lang/i18n';
import IndexedDBProvider from 'IndexedDB/IndexedDBProvider';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

const client = new QueryClient();

root.render(
 
    <BrowserRouter basename="/">
      <StyledEngineProvider injectFirst>
        <GlobalContextProvider>
          <MuiProvider>
            <IndexedDBProvider>
              <span dir="ltr">
                <QueryClientProvider client={client}>
                  <App />
                </QueryClientProvider>
              </span>
            </IndexedDBProvider>
          </MuiProvider>
        </GlobalContextProvider>
      </StyledEngineProvider>
    </BrowserRouter>
 
);

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://cra.link/PWA
// register();
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
